
import BaseView from "@core/View.js";

export default class ServiceWapView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._extraBoxEl;
        this._parentModel = this._model._parent;
        this._itemEls = {};
    }

    getItems(){
        let html = "";
        this._model._items.forEach((item) => {
            if (!this._parentModel._invalid) {
                html +=  `<div class="item_content ${this.getInvalidInfo(item).cls}"  csid='${item._id}'>`;
            }else{
                html +=  `<div class="item_content disable" csid='${item._id}'>`;
            }
            html +=  `
                    <div class="e_goods_desc">
                    <span class="le_tip_btn_solid" style="display:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? 'inline-block':'none'}">${this.getInvalidInfo(item).msg}</span>
                    <h5 class='services_h lenovo-emoji' style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}">${item._name}</h5>
                    <span style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" class="e_price" sid='${item._id}'>¥${item._price}</span>
                    <span style="opacity:${(this._model._parent._invalid || item._invalid || !this._model._parent._marketable || this._model._parent._stock <= 0 ) ? '0.5' : '1'}" class="e_num">&nbsp;x&nbsp;${item._count}</span>
                    </div>
                </div>`;
            this._itemEls[item._id] = null;
        });
        return html;
    }

    render(){
        let html = "";
        html += `<div class="extra_item service ${this.getInvalidInfo().cls}">
            <h3 class="e_name">服务</h3>
            <div class="extra_item_content">${this.getItems()}</div>
        </div>`;
        $(this._parentEl).append($(html));
        this._el = this._model._parent._view._extraBoxEl.find('div.service');
        
        for(let i in this._itemEls){
            this._itemEls[i] = this._el.find("div[csid="+i+"]");
        }
    }

   
}